import { FC, useMemo } from 'react';

import { motion } from 'framer-motion';

import { x } from '@ui-furniture/style';

import { ButtonGrid } from '../ui/button-grid';

export const ActionsChatInput: FC<{
  config: {
    primaryLabel: string;
    secondaryLabel?: string;
  };
  onAnswer: (selectedOption: 'primary' | 'secondary') => void;
}> = ({ onAnswer, config: { primaryLabel, secondaryLabel } }) => {
  const options = useMemo(() => {
    const optionsArray: Array<{
      label: string;
      onClick: () => any;
      version: 'primary' | 'secondary';
    }> = [
      {
        label: primaryLabel,
        onClick: () => onAnswer('primary'),
        version: 'primary',
      },
    ];
    if (secondaryLabel) {
      optionsArray.unshift({
        label: secondaryLabel,
        onClick: () => onAnswer('secondary'),
        version: 'secondary',
      });
    }
    return optionsArray;
  }, [primaryLabel, secondaryLabel]);
  return (
    <motion.div layout style={{ overflow: 'hidden', padding: '1px' }}>
      <x.div mb='sm'>
        <ButtonGrid options={options} />
      </x.div>
    </motion.div>
  );
};
